import { useNavigate, useSearchParams } from 'react-router-dom'

import { Button } from 'featureSliced/entities/Button'
import TableSelect from 'featureSliced/features/TableSelect'
import { getNavLink } from 'featureSliced/shared/utils/getNavLink'
import { loadTableStatus } from 'featureSliced/shared/store/reducers/QRMenuTableReducer/actionCreator'

import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'
import { RenderIf } from 'components/RenderIf'

export const ButtonsQRM = () => {
  //
  // Hooks
  const t = useTranslations()
  const dispatch = useMyDispatch()
  const openModal = useOpenModal()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const table = searchParams.get('table')

  // Store
  const restaurants = useMySelector((state) => state.restaurants)
  const paymentVariant = useMySelector((state) => state.app.menu.paymentVariant)
  const bookingVariant = useMySelector((state) => state.app.menu.bookingVariant)
  const disabledByMobileWaiter = useMySelector(
    (state) => state.app.menu.disabledByMobileWaiter
  )
  const isPaymentConfigured = useMySelector(
    (state) => state.app.menu.isPaymentConfigured
  )

  // Functions
  const goToMenu = () => {
    dispatch(loadTableStatus())
    navigate(getNavLink(searchParams, 'menu'))
  }

  const goToPayment = (tableParam?: string | number) => {
    dispatch(loadTableStatus())
    navigate(`/payment?table=${tableParam}`)
  }

  const handlePayClick = () => {
    if (table && !disabledByMobileWaiter) {
      goToPayment(table)
    } else {
      openTableIdPrompt()
    }
  }

  const openTableIdPrompt = () => {
    openModal({
      id: 'TABLE_SELECTION',
      title: '',
      shouldHideCross: true,
      components: [
        ({ closeThisModal }) => (
          <TableSelect
            onClose={(tableId?: string | number) => {
              goToPayment(tableId)
              closeThisModal()
            }}
          />
        ),
      ],
    })
  }

  return (
    <RenderIf condition={process.env.REACT_APP_IS_CLIC === '0'}>
      <RenderIf condition={bookingVariant !== 3}>
        <Button
          buttonType="common"
          onClick={goToMenu}
          isLoading={!restaurants?.length}
        >
          {t('cover.menu')}
        </Button>
      </RenderIf>
      <RenderIf
        condition={
          paymentVariant === 2 &&
          bookingVariant !== 1 &&
          !disabledByMobileWaiter &&
          isPaymentConfigured
        }
      >
        <Button buttonType="stroke" onClick={handlePayClick}>
          {t('cover.pay')}
        </Button>
      </RenderIf>
    </RenderIf>
  )
}
